import React, { useState, useEffect } from "react";
import { Instagram } from 'lucide-react';
import { Youtube } from 'lucide-react';

const TravelSection = () => {
  const [isMobile, setIsMobile] = useState(false);
  
  useEffect(() => {
    // Check if we're on mobile when component mounts
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    
    // Initial check
    checkMobile();
    
    // Set up listener for window resizing
    window.addEventListener('resize', checkMobile);
    
    // Clean up
    return () => {
      window.removeEventListener('resize', checkMobile);
    };
  }, []);

  // Instagram posts data
  const instagramPosts = [
    {
      id: "post1",
      thumbnail: "/images/instagram-post1.webp",
      link: "https://www.instagram.com/p/DJezSZ-oR1Y/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA==",
      caption: "Naivasha, Kenya"
    },
    {
      id: "post2",
      thumbnail: "/images/instagram-post2.webp",
      link: "https://www.instagram.com/p/DJBb54uIQ9u/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA==",
      caption: "Ngong Hills"
    },
    {
      id: "post3",
      thumbnail: "/images/instagram-post3.webp",
      link: "https://www.instagram.com/p/DIvaXZ_oYdH/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA==",
      caption: "KICC Grounds"
    }
  ];
  
  return (
    <section className="travel-section section-padding">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-md-10 text-center">
            <h2 className="section-heading mb-3">Travel With Wamae – Wamae Travels</h2>
            <p className="section-description mb-5">
              Join me on my creative journeys around the world as I explore new cultures, 
              find artistic inspiration, and document the beauty of our planet through both 
              pencil and camera lens. My travel vlogs capture the intersection of art and adventure.
            </p>
          </div>
        </div>
        
        <div className="row">
          {/* Featured YouTube Video */}
          <div className={`${isMobile ? 'col-12' : 'col-lg-7'} mb-4`}>
            <div className="featured-content-container">
              <div className="ratio ratio-16x9">
                <iframe 
                  src="https://www.youtube.com/embed/7SmBLN8n63U" 
                  title="Kelvin Wamae Travel Vlog" 
                  allowFullScreen
                  className="rounded content-shadow"
                ></iframe>
              </div>
              <div className="content-caption mt-2">
                <h5>Art, Travel & the Beauty of the Beach</h5>
              </div>
            </div>
          </div>
          
          {/* Instagram Posts */}
          <div className={`${isMobile ? 'col-12' : 'col-lg-5'}`}>
            <div className="social-feed">
              <h4 className="sub-heading mb-3">Instagram Highlights</h4>
              <div className="row g-2">
                {instagramPosts.map((post) => (
                  <div className="col-4" key={post.id}>
                    <a 
                      href={post.link} 
                      target="_blank" 
                      rel="noopener noreferrer"
                      className="social-post-link"
                    >
                      <div className="social-post">
                        <img 
                          src={post.thumbnail} 
                          alt={post.caption} 
                          className="img-fluid rounded content-shadow-sm"
                        />
                        <div className="social-overlay">
                          <Instagram className="me-2 w-5 h-5 text-white" />
                        </div>
                        <div className="social-caption">
                          <span>{post.caption}</span>
                        </div>
                      </div>
                    </a>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
        
        {/* Call to Action Buttons */}
        <div className="row justify-content-center mt-5">
          <div className="col-md-8 text-center">
            <div className="cta-buttons">
              <a 
                href="https://www.youtube.com/@WamaeTravels" 
                target="_blank" 
                rel="noopener noreferrer"
                className="btn btn-primary youtube-btn me-3 mb-3"
              >
                <Youtube className="me-2 w-5 h-5 text-white" />
                Watch More on YouTube
              </a>
              <a 
                href="https://www.instagram.com/wamae_travels/" 
                target="_blank" 
                rel="noopener noreferrer"
                className="btn btn-secondary instagram-btn mb-3"
              >
                <Instagram className="me-2 w-5 h-5 text-white" />
                Follow My Travel Journey
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TravelSection;